import { Resource, CombineResource } from "restdux";
import { getAPIUrl, getHeaders, transformIndex } from "../global/globals";

export type ChangeType = 'SC'|'RS'|'NS';

export interface IReturn {
	appointment: number;
	change_type: ChangeType;
	date: string;
	id: number;
	note: string;
	user: number;
}

export type ISend = Partial<IReturn>;

export interface IParameters {}

const resource = Resource<IParameters, ISend, IReturn>({
	headers: getHeaders,
	methodUpdate: "PATCH",
	name: "appointmenthistory",
	rootUrl: getAPIUrl("/appointmenthistories"),
	transformIndex,
});

export const { actions, types, reducer } = CombineResource(resource, {});